export const FETCH_USER_CONNECTION_STATUS = "fetch-user-connection-status";
